import './cursor.js';
import { initializeSwiper } from './swiper.js';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { initializeScrollAnimations } from './gsap-animation.js';
import Lenis from 'lenis'
import { initBarba } from './barba.js';

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

export const lenis = new Lenis({
	duration: 1.45,
	direction: 'vertical',
	gestureDirection: 'vertical',
	smooth: true,
	mouseMultiplier: 1,
	smoothTouch: false,
	touchMultiplier: 2,
	infinite: false,
});

function raf(time) {
	lenis.raf(time);
	requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

export function setFullHeight() {
	const vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
}

export function setRadiusSwiper() {
	const swiperElementDimensions = document.querySelector('.section-hero-slider .swiper');

	if (swiperElementDimensions) {
		const scallingSection = document.querySelector('.scalling-section');
		const swiperWidth = swiperElementDimensions.clientWidth;
		const swiperHeight = swiperElementDimensions.clientHeight;

		const halfWidth = swiperWidth / 2;
		const halfHeight = swiperHeight / 2;

		const hypotenuse = Math.sqrt(Math.pow(halfWidth, 2) + Math.pow(halfHeight, 2));
		scallingSection.style.setProperty('--clip-radius', `${hypotenuse}px`);
	}
}

export function closeModal() {
	document.body.classList.remove('is-overflow');
	document.body.classList.remove('is-overlay');
	const closeElement = document.querySelector('[data-close]');

	if (closeElement) {
		closeElement.classList.remove('active');
	}

	lenis.start();
}

export function contactForm() {
	const formButton = document.getElementById('form');
	const contactForm = document.querySelector('.contact-form');
	const closeButton = document.getElementById('close-form');

	if (formButton) {
		formButton.addEventListener('click', () => {
			document.body.classList.add('is-overflow');
			document.body.classList.add('is-overlay');
			contactForm.classList.add('active');
			lenis.stop();
		});
	}

	if (closeButton) {
		closeButton.addEventListener('click', () => {
			closeModal();
		});
	}
}

export function closePopupEsc() {
	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape' || event.key === 'Esc') {
			closeModal();
		}
	});
}

export function footerLogoAnimation() {

	const myElement = document.body;

	function sequentialClassToggle(element, classes, delay) {
		let index = 0;

		function toggleNextClass() {
			element.classList.remove(classes);
			if (index < classes.length) {
				const currentClass = classes[index];

				// Dodaj klasę
				element.classList.add(currentClass);

				// Usuń klasę po pewnym czasie
				setTimeout(() => {
					element.classList.remove(currentClass);

					// Przejdź do następnej klasy
					index++;
					toggleNextClass();
				}, delay);
			} else {
				// Zresetuj indeks po zakończeniu i uruchom sekwencję ponownie
				index = 0;
				toggleNextClass();
			}
		}

		toggleNextClass();
	}


	const classList = ['animation-1', 'animation-2', 'animation-3'];
	const delay = 2000;

	sequentialClassToggle(myElement, classList, delay);
}


export function menuThumbnailHover() {
	const mainImageUrls = document.querySelectorAll('a[data-image]');

	mainImageUrls.forEach(function (link, index) {
		const imageUrl = link.getAttribute('data-image');
		const thumbId = link.getAttribute('data-thumb');

		let topParentLi = link.closest('li');
		while (topParentLi && topParentLi.parentElement.closest('li')) {
			topParentLi = topParentLi.parentElement.closest('li');
		}

		const defaultLink = topParentLi ? topParentLi.querySelector('a[data-image]') : null;
		const imageUrlDefault = defaultLink ? defaultLink.getAttribute('data-image') : '';

		let thumbElement;

		link.addEventListener('mouseover', () => {
			thumbElement = document.querySelector('#thumb-' + thumbId);
			thumbElement.style.setProperty('--data-image-url', 'url(' + imageUrl + ')');
		});

		link.addEventListener('mouseout', () => {
			thumbElement.style.setProperty('--data-image-url', 'url(' + imageUrlDefault + ')');
		});
	});
}

export function scrollToSectionFromHero() {
	const buttonHero = document.querySelector('.section-hero .button .btn');
	if (buttonHero) {
		buttonHero.addEventListener('click', (event) => {
			event.preventDefault();

			const hash = buttonHero.getAttribute('href');

			const target = document.querySelector(hash);

			if (target) {
				target.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}
		})
	}
}

export function fireMobileMenu() {
	const buttonMenuOpen = document.querySelector('.header__mobile button');
	const buttonMenuClose = document.querySelector('.header__mobile-close button');
	const menu = document.querySelector('.header__navigation');

	buttonMenuOpen.addEventListener('click', () => {
		menu.classList.add('active');
		document.body.classList.add('is-overflow');

		setTimeout(function () {
			buttonMenuClose.classList.add('is-active');
		}, 300);

	});

	buttonMenuClose.addEventListener('click', () => {
		menu.classList.remove('active');
		document.body.classList.remove('is-overflow');
		buttonMenuClose.classList.remove('is-active');
	});

	const menuParentItems = document.querySelectorAll('.menu-item-has-children:not(.hide-on-mobile) > a');

	if (window.innerWidth < 992) {
		menuParentItems.forEach(function (menuParentItem) {
			menuParentItem.addEventListener('click', (event) => {

				event.preventDefault();
				event.stopPropagation();

				const subMenu = menuParentItem.nextElementSibling;
				if (subMenu && subMenu.classList.contains('sub-menu')) {
					subMenu.style.display = (subMenu.style.display === 'block') ? 'none' : 'block';
				}
			})
		})
	}

	const menuBackButtons = document.querySelectorAll('[data-back-button]');
	menuBackButtons.forEach(function (menuBackButton) {
		menuBackButton.addEventListener('click', (event) => {
			const sm = menuBackButton.closest('.sub-menu');
			sm.style.display = 'none';
		});
	});


	document.addEventListener('click', function (event) {
		let target = event.target;

		while (target && target !== document) {
			if (target.getAttribute('data-anchor') === 'true') {
				menu.classList.remove('active');
				document.body.classList.remove('is-overflow');
			}
			target = target.parentNode;
		}
	});
}


export function sectionStickyMore() {
	const button = document.getElementById('show-more');
	const content = document.getElementById('show-more-content');

	if (button && content) {
		button.addEventListener('click', function () {
			const isExpanded = button.getAttribute('aria-expanded') === 'true';
			const newState = !isExpanded;

			button.setAttribute('aria-expanded', newState);
			content.setAttribute('aria-hidden', !newState);

			button.textContent = newState
				? button.dataset.less
				: button.dataset.more;
		});
	}
}


document.addEventListener('DOMContentLoaded', function () {

	initBarba();
	initializeSwiper();
	setFullHeight();
	setRadiusSwiper();
	fireMobileMenu();

	window.addEventListener('resize', function () {
		ScrollTrigger.getAll().forEach(trigger => trigger.kill());
		initializeScrollAnimations();
	});
});